import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations, Roles } from "../../shared/permissions/permissionsConfig"
import { getAllAdmNumbers, getAssignedAdmNumbers } from "../../user/utils/userHelper"
import { getSalesVolumeForAdms } from "../utils/salesVolumeForAdms"

export const queryAdmVolumeOverview = {
  async admVolumeOverview(_parent, args, context, _info) {
    const {
      page,
      limit = 10,
      sort = {
        orderBy: "admNumber",
        direction: "asc",
      },
    } = args

    const user = context?.user
    let assignedAdms = []

    await checkPermissions({
      user,
      domainObject: DomainObjects.VOLUME,
      operation: Operations.READ,
    })

    if (user.role === Roles.ADMIN) {
      assignedAdms = await getAllAdmNumbers()
    }

    if ([Roles.REGIONAL_LEAD, Roles.ADM_GVL].includes(user.role)) {
      assignedAdms = await getAssignedAdmNumbers({
        employeeNumber: user.employeeNumber,
      })
    }

    return await getSalesVolumeForAdms({
      admNumbers: assignedAdms?.assignedAdmNumbers,
      limit,
      page,
      sort,
    })
  },
}
